import styled from 'styled-components';

const ProviderLogo = styled.img`
  height: 40px;
  margin-bottom: 16px;
`;

export default ProviderLogo;
